import {Hub} from '@aws-amplify/core';
import intl from "react-intl-universal";

import type {RootStoreModel} from "@stores/RootStore";


import {snackBarRef} from "@stores/snackbarRef";


export const initNetworkListener = (rootStore: RootStoreModel) => {
    let previousNetworkState: string | null = null;
    return Hub.listen('datastore', async hubData => {
        const  { event } = hubData.payload;
        if (event === 'networkStatus') {
            if (navigator.onLine) {
                rootStore.setIsOnline(true);
                if (previousNetworkState === 'offline') {
                    snackBarRef.current?.enqueueSnackbar({
                        variant: "success",
                        message: intl.get('network-status.online').d('You are now back online!')
                    })
                }
                previousNetworkState = 'online';
            } else {
                rootStore.setIsOnline(false);
                if (previousNetworkState === 'online') {
                        snackBarRef.current?.enqueueSnackbar({
                        variant: "warning",
                        message: intl.get('network-status.offline').d('You are now offline, all changed will be synced once the internet is restored')
                    });
                }
                previousNetworkState = 'offline';
            }
        }
    }) as () => void;
}
